// Example: root reducer (if you want to combine more slices)
import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import autoPilotReducer from './slices/autoPilotSlice';

const rootReducer = combineReducers({
  user: userReducer,
  autoPilot: autoPilotReducer,
});

export default rootReducer;
